<template>
  <div class="callOpt">
    <div id="mySoftphone" style="width: 80%; display: none"></div>
    <el-row>
      <el-col :span="9">
        <div class="callNumberWrap">
          <!-- 呼叫 -->
          <ul class="callOptIconWrap">
            <li class="iconItem active" v-if="statusDic && !restState">
              <img src="../assets/img/1.png" class="icon" alt="" />
              <p>就绪</p>
            </li>
            <li
              class="iconItem active"
              @click="stopRest"
              v-if="!statusDic && !restState"
            >
              <img src="../assets/img/1_f.png" class="icon" alt="" />
              <p>未就绪</p>
            </li>
            <li
              class="iconItem active"
              @click="stopRest"
              v-if="statusDic && restState"
            >
              <img src="../assets/img/1_r.png" class="icon" alt="" />
              <p>结束小休</p>
            </li>
            <li
              class="iconItem active"
              @click="answerCallsOpt"
              v-if="statusDic == 3"
            >
              <img src="../assets/img/2.png" class="icon" alt="" />
              <p>接听</p>
            </li>
            <li class="iconItem active" v-if="statusDic != 3">
              <img src="../assets/img/2_f.png" class="icon" alt="" />
              <p>接听</p>
            </li>
            <li
              class="iconItem active"
              @click="dialingOpt('1')"
              v-if="statusDic && statusDic != 3 && !restState"
            >
              <img src="../assets/img/3.png" class="icon" alt="" />
              <p>拨号</p>
            </li>
            <!-- @click="dialingOpt1" -->
            <li
              class="iconItem active"
              v-if="!statusDic || statusDic == 3 || restState"
            >
              <img src="../assets/img/3_f.png" class="icon" alt="" />
              <p>拨号</p>
            </li>
            <li
              class="iconItem active"
              @click="keepCallOpt"
              v-if="stateId == '3'"
            >
              <img src="../assets/img/4.png" class="icon" alt="" />
              <p>{{ holdText }}</p>
            </li>
            <li class="iconItem active" v-if="stateId != '3'">
              <img src="../assets/img/4_f.png" class="icon" alt="" />
              <p>{{ holdText }}</p>
            </li>
            <li
              class="iconItem active"
              @click="blindShow"
              v-if="stateId == '3'"
            >
              <img src="../assets/img/7.png" class="icon" alt="" />
              <p>转接</p>
            </li>
            <li class="iconItem active" v-if="stateId != '3'">
              <img src="../assets/img/7_f.png" class="icon" alt="" />
              <p>转接</p>
            </li>

            <el-popover placement="top" width="160" v-model="visible">
              <el-input v-model="blindPhone"></el-input>
              <div style="text-align: right; margin: 10px 0">
                <el-button size="mini" type="text" @click="visible = false"
                  >取消
                </el-button>
                <el-button type="primary" size="mini" @click="blindToPhone"
                  >确定
                </el-button>
              </div>
            </el-popover>

            <li
              class="iconItem active"
              @click="hangUpOpt"
              v-if="stateId == '3'"
            >
              <img src="../assets/img/5.png" class="icon" alt="" />
              <p>挂断</p>
            </li>
            <li class="iconItem active" v-if="stateId != '3'">
              <img src="../assets/img/5_f.png" class="icon" alt="" />
              <p>挂断</p>
            </li>
            <li
              class="iconItem active"
              @click="rest"
              v-if="statusDic && !restState"
            >
              <img src="../assets/img/6.png" class="icon" alt="" />
              <p>休息</p>
            </li>
            <li
              class="iconItem active"
              @click="stopRest"
              v-if="!statusDic || restState"
            >
              <img src="../assets/img/6_f.png" class="icon" alt="" />
              <p>休息</p>
            </li>
          </ul>
        </div>
      </el-col>
      <el-col :span="4" class="flex justify-center align-center">
        <!-- 状态 -->
        <el-dropdown
          @command="statesStatusChange1"
          split-button
          trigger="click"
          size="medium"
        >
          <img
            src="../assets/img/statusIcon.png"
            class="el-input__icon statusIcon"
          />
          <span>{{ stateLabel }}</span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="item in statusOption"
              :key="item.value"
              :command="item.value"
            >
              {{ item.label }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
      <el-col :span="3" class="callNumberEdit">
        <el-input
          placeholder="请输入拨打号码"
          v-model="aghentPhone"
          style="width: 180px"
          size="small"
        >
          <img
            slot="append"
            src="../assets/img/phoneBookIcon.png"
            alt=""
            class="phoneBookIcon"
          />
        </el-input>
      </el-col>
      <el-col
        :span="3"
        class="flex justify-around align-center headline-dripdown"
      >
        <!-- 账号选择 -->
        <el-dropdown
          @command="callIdChange"
          split-button
          trigger="click"
          size="medium"
        >
          <i class="el-icon-user" />
          <span>{{ callIdLabel }}</span>
          <!-- <span>{{ $store.state.info.seatNo }}</span> -->
          <el-dropdown-menu slot="dropdown" class="callIdDown">
            <el-dropdown-item
              v-for="item in callIdOption"
              :key="item.value"
              :command="item.value"
            >
              {{ item.label }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
      <el-col :span="1" class="flex">
        <el-button
          type="primary"
          size="small"
          @click="signIn"
          v-if="!statusDic"
          style="background: #3875ff"
          >签入
        </el-button>
        <el-button type="primary" size="small" @click="signOut" v-if="statusDic"
          >签出
        </el-button>
      </el-col>
      <!-- <el-button type="primary" @click="chufa">触发弹框</el-button> -->
      <el-col :span="4" class="flex justify-end align-right">
        <!-- <div>
            <el-tooltip
                class="item"
                effect="light"
                :content="loginName"
                placement="top-start"
            >
                <img
                    src="../assets/img/connectorMan.png"
                    alt=""
                    style="width: 27px; height: 27px"
                    title="用户名"
                />
            </el-tooltip>
        </div> -->
        <div class="rightIcon">
          <img
            src="../assets/img/phoneRight1.png"
            alt=""
            title="话务小结"
            @click="toOperator"
          />
          <p>话务小结</p>
        </div>
        <div class="rightIcon">
          <img
            src="../assets/img/phoneRight2.png"
            alt=""
            title="漏接来电"
            @click="toLiaison"
          />
          <p>漏接来电</p>
        </div>
        <!-- <div>

          <el-tooltip
                class="item"
                effect="light"
                content="退出账号"
                placement="top-start">
        <img src="../assets/img/loginOutIcon.png" alt="" style="width: 27px;height: 27px;" title="退出账号" @click="loginOut">
        </el-tooltip>
      </div> -->
      </el-col>
    </el-row>
    <el-dialog
      title="话务首页"
      width="80%"
      height="363px"
      :visible.sync="infor1"
      :modal-append-to-body="false"
    >
      <DialogHomePage v-if="infor1" :phone="info1Phone"></DialogHomePage>
    </el-dialog>
    <!-- <el-dialog
      title="退出管理平台"
      :visible.sync="outDialogVisible"
      width="30%"
      >
      <span>您确定要退出吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="outDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureLoginOut">确 定</el-button>
      </span>
      </el-dialog> -->
    <traffic-open
      v-if="trafficState"
      :openData="trafficInfo"
      @contactTap="contactTap"
    ></traffic-open>
  </div>
</template>

<script>
import { metaDataMgrDao } from "@/api/dao.js"
import trafficOpen from "./trafficOpen.vue"
import DialogHomePage from "./home_page2.vue"
import request from "@/utils/request.js"
import exportVue from "@/utils/exportVue"

export default {
  // 原代码
  // props: ["userId", "aghents"],
  props: {
    userId: {
      type: String,
      default:
        "06a942d7-0241-4428-8f6f-bbf0695e60ae73a87e63-be16-4ed4-be70-876513c50dec",
    },
    aghents: {},
    msglist: [],
  },
  data() {
    return {
      trafficState: false,
      trafficInfo: {},
      outDialogVisible: false,
      info1Phone: "",
      belongAddressId: "",
      username: "",
      loginName: JSON.parse(localStorage.getItem("czUserInfo")).loginName,
      name: "",
      idCardNo: "",
      checkList: [""],
      zhixian: "",
      zhimang: "",
      // aghentPhone: '',
      statusDic: "",
      statusOption: [
        {
          value: "4",
          label: "置忙",
        },
        {
          value: "2",
          label: "置闲",
        },
      ],
      transferDic: "",
      transferOption: [
        {
          value: "1",
          label: "转接内线",
        },
        {
          value: "2",
          label: "转接外线",
        },
      ],
      stateLabel: "状态",
      stateId: "",
      stateList: [
        {
          value: "2",
          label: "置闲",
        },
        {
          value: "4",
          label: "置忙",
        },
        {
          value: "0",
          label: "离线",
        },
        {
          value: "1",
          label: "登录",
        },
        {
          value: "3",
          label: "话务忙",
        },
        {
          value: "5",
          label: "话后忙",
        },
      ],
      meetingDic: "",
      meetingOption: [
        {
          value: "1",
          label: "内线会议",
        },
        {
          value: "2",
          label: "外线会议",
        },
      ],
      callTool: "",
      holdText: "保持",
      callState: "", // 话务状态
      state: {
        ready: false,
        answer: false,
        dial: false,
        keep: false,
        hangUp: false,
      },
      restState: false,
      nextState: false,
      callIdDic: "",
      agentGroupId: "1",
      agentChannel: "1",
      callIdOption: [],
      _gap_time: "",
      _beforeUnload_time: "",
      time: "",
      blindPhone: "",
      visible: false,
      timer: "",
      timeShow: true,
      setTimer: "",
      isDial: true,
      stateEdit: true,
      infor1: false,
      callname: "",
      canPhone: "",
      outCall: 0,
      // callIdLabel:'',
    }
  },

  computed: {
    // 状态
    statusLabel() {
      let label = "状态"
      this.statusOption.forEach((item) => {
        if (item.value == this.statusDic) {
          label = item.label
        }
      })
      return label
    },
    // 坐席ID选择
    callIdLabel() {
      let label = ""
      this.callIdDic = this.$store.state.seatNo
      // console.log(this.callIdDic, this.callIdOption, "数据")
      if (this.callIdOption.length > 0) {
        this.callIdOption.forEach((item) => {
          if (item.value == this.callIdDic) {
            label = item.label
          }
        })
      } else {
        label = this.callIdDic
      }

      return label
      // return this.callIdDic
    },

    // 转接
    transferLabel() {
      let label = "转接"
      this.transferOption.forEach((item) => {
        if (item.value == this.transferDic) {
          label = item.label
        }
      })
      return label
    },
    // 会议
    meetingLabel() {
      let label = "会议"
      this.meetingOption.forEach((item) => {
        if (item.value == this.meetingDic) {
          label = item.label
        }
      })
      return label
    },
    aghentPhone: {
      get() {
        return this.$store.getters.centerPhone
          ? this.$store.getters.centerPhone
          : ""
      },
      set(newsData) {
        this.$store.dispatch("setPhone", newsData)
      },
    },
  },

  mounted() {
    //监听页面关闭

    // window.addEventListener( 'beforeunload', e => this.set() );
    window.addEventListener("beforeunload", (e) => this.beforeunloadFn())
    window.addEventListener("unload", (e) => this.unloadFn())

    if (localStorage.getItem("czUserInfo")) {
      var a = JSON.parse(localStorage.getItem("czUserInfo")).belongAddressId
      this.belongAddressId = a
      console.log(this.belongAddressId)

      // var a =  localStorage.getItem("user");
      // this.belongAddressId = a;
      // console.log(this.belongAddressId);
    }
    if (localStorage.getItem("czUserInfo")) {
      var username = JSON.parse(localStorage.getItem("czUserInfo")).loginName
      this.username = username
    }
    if (localStorage.getItem("czUserInfo")) {
      var name = JSON.parse(localStorage.getItem("czUserInfo")).name
      var idCardNo = JSON.parse(localStorage.getItem("czUserInfo")).idCardNo
      let seatNo = JSON.parse(localStorage.getItem("czUserInfo")).seatNo
      this.name = name
      this.idCardNo = idCardNo
      this.seatNo = seatNo
    }
    //定时器监听状态    暂时注释掉
    this.timer = setInterval(this.getState, 1000)

    // this.callIdDic = 1014
    // if (this.$store.state.seatNo) {
    if (this.$store.state.seatNo) {
      this.callIdDic = this.$store.state.seatNo
      this.signIn()
      setTimeout(() => {
        exportVue.$on("question", (data) => {
          if (data == true) {
            this.nextState = true
            this.dialingOpt("2")
          }
        })
      }, 100)
      setTimeout(() => {
        exportVue.$on("importantInfo", (data) => {
          if (data == true) {
            this.nextState = true
            this.dialingOpt("2")
          }
        })
      }, 100)
    } else {
      setTimeout(() => {
        this.initCall()
      }, 0)
    }
    // this.getCurrentCallID()
  },

  created() {
    this.getCallIdList()
    this.$store.dispatch("setPhone", "")
    if (this.$route.params.phone) {
      this.aghentPhone = this.$route.params.phone
    }
  },
  methods: {
    // 话务信息

    phoneInfo() {
      const that = this
      request({
        url: "/jjyl/traffic/callInfo/info/findSeatInfo",
        method: "POST",
        data: {
          agentID: this.callIdDic,
          outCall: this.outCall,
        },
      }).then((res) => {
        if (res.code === 200) {
          that.trafficState = true
          that.trafficInfo = {
            state: true,
            phone: res.content.phone,
            outCall: that.outCall,
            callid: res.content.callID,
            callmanid: res.content.callmanid,
            callman: res.content.callman,
          }
          that.nextState = false
        }
      })
    },
    // 话务弹窗
    contactTap() {
      this.trafficInfo = {}
      this.trafficState = false
      this.hangUpOpt()
      // 做判断关于重要提醒
      if (sessionStorage.getItem("phoneStart")) {
        exportVue.$emit("updatePhone", true)
        sessionStorage.removeItem("phoneStart")
      }
    },
    //跳转到漏接来电
    toLiaison() {
      this.$router.push({
        path: "/liaison",
      })
    },

    //跳转到话务小结
    toOperator() {
      this.$router.push({
        path: "/operator",
      })
    },
    // 触发弹框
    // chufa(){
    //   this.infor1= true;
    // },
    //获取当前状态
    getState() {
      let state = this.getAgentStateOpt()
      let state1 = this.callTool.GetLineState()
      if (state == -1) {
        state = 0
      }
      this.stateId = state
      this.$store.commit("stateId", this.stateId)
      this.createState(state)
      this.statusDic = state
      this.$store.commit("statusDic", this.statusDic)
      if (state1 == 1) {
        let phone = this.callTool.GetCaller()
        this.aghentPhone = phone
        this.$store.dispatch("setPhone", this.aghentPhone)
      } else if (state == 3) {
        if (this.isDial) {
          let phone = this.callTool.GetCaller()
          // alert("thisphone"+phone)
          // this.infor1 = true;
          this.info1Phone = phone

          request({
            url: "/jjyl/WebCustomer/info/getCustomerByPhone",
            method: "POST",
            data: {
              belongAddressId: "06a942d7-0241-4428-8f6f-bbf0695e60ae",
              phone: this.info1Phone,
            },
          }).then((resp) => {
            if (resp.code == "200") {
              if (resp.content != null) {
                this.$emit("val", resp)
                localStorage.setItem("provinceId", resp.content.provinceId)
                localStorage.setItem("zxName", resp.content.name)
              } else {
              }
            }
          })
          // this.$router.push({ path: '/home_page', query: { key: phone }});
          this.isDial = false
        }
        var userIds = this.$props.userId
        this.updateAgentType(userIds, "1", 3)
      } else if (state == 5) {
        const that = this
        if (that.timeShow) {
          that.isDial = true
          that.timeShow = false
          if (that.stateEdit) {
            that.setTimer = setTimeout(() => {
              that.statesStatusChange("2")
              that.timeShow = true
            }, 60000)
          }
        }
        var userIds = this.$props.userId
        this.updateAgentType(userIds, "1", 5)
      } else if (state == 4) {
        const that = this
        if (!that.timeShow) {
          that.timeShow = true
          clearTimeout(that.setTimer)
        }
      }
    },
    unloadFn() {
      this._gap_time = new Date().getTime() - this._beforeUnload_time
      if (this._gap_time <= 5) {
        //请求退出接口
        var userIds = this.$props.userId
        this.updateAgentType(userIds, 0, 0)
        this.signOut()
      }
    },
    beforeunloadFn() {
      this._beforeUnload_time = new Date().getTime()
    },
    // 获取坐席ID列表
    getCallIdList() {
      request({
        url: "/jjyl/agent/info/findAgent",
        method: "POST",
        data: {
          belongAddressId: "06a942d7-0241-4428-8f6f-bbf0695e60ae",
          pageSize: 500,
          pageNo: 1,
        },
      }).then((resp) => {
        if (resp.code == "200") {
          if (resp.content != null) {
            let callIdArry = []
            resp.content.list.forEach((item) => {
              let callIdObj = {
                value: item.agentExt,
                label: item.agentExt,
                agentGroupId: item.agentGroupId,
                agentChannel: item.agentChannel,
              }
              callIdArry.push(callIdObj)
            })
            this.callIdOption = callIdArry
            this.callIdDic = this.$store.state.seatNo
          } else {
          }
        }
      })
    },
    //获取当前登录用户ID
    getCurrentCallID() {
      // 坐席员的id 获取坐席员相关信息 连接ACD服务器
      request({
        url: "/jjyl/agent/info/findAgentById",
        method: "POST",
        data: {
          ids: this.$props.userId,
        },
      }).then((resp) => {
        if (resp.code == "200") {
          if (resp.content != null) {
            let list = resp.content
            this.callIdDic = list.agentExt
            this.$store.commit("setNo", list.agentExt)
            this.agentGroupId = list.agentGroupId
            this.agentChannel = list.agentChannel
          }
        }
      })
    },
    //登入按钮事件
    signIn() {
      //this.callIdDic=1104
      if (this.callIdDic) {
        // this.initCall();
        this.toACD()
        // this.ACDlogin();
      } else {
        this.$message({
          showClose: true,
          message: "请先选择账户",
          type: "error",
          offset: 50,
        })
      }
    },
    //登出按钮事件
    signOut() {
      const that = this
      let Logout = that.callTool.Logout()
      var userIds = that.$props.userId
      if (Logout) {
        this.$store.dispatch("setPhone", "")
        if (userIds != null && userIds != "") {
          that.updateAgentType(userIds, 0, 0)
          that.stateId = "0"
          that.$store.commit("stateId", that.stateId)
          that.createState("0")
          that.statusDic = 0
          this.$store.commit("statusDic", this.statusDic)
        } else {
          alert("状态错误，请联系管理员")
        }
      }
    },
    //小休
    rest() {
      const that = this
      var userIds = that.$props.userId
      that.updateAgentType(userIds, "1", 6)
      this.statesStatusChange("4")
      that.restState = true
      this.$store.commit("restState", that.restState)
    },
    //停止小休
    stopRest() {
      const that = this
      var userIds = that.$props.userId
      that.updateAgentType(userIds, "1", 2)
      this.statesStatusChange("2")
      that.restState = false
      this.$store.commit("restState", that.restState)
    },
    //转接
    blindShow() {
      this.visible = true
    },
    blindToPhone() {
      const that = this
      if (that.blindPhone.length > 4) {
        if (this.blindPhone) {
          let blind = that.callTool.BlindTransfer(that.blindPhone)
          if (blind) {
            that.visible = false
            that.blindPhone = ""
            this.$message({
              showClose: true,
              message: "转接成功",
              type: "success",
              offset: 50,
            })
          }
        } else {
          that.$message({
            showClose: true,
            message: "请输入转接号码",
            type: "error",
            offset: 50,
          })
        }
      } else {
        if (this.blindPhone) {
          let blind = that.callTool.BlindTransferByAgentID(that.blindPhone)
          if (blind) {
            that.visible = false
            that.blindPhone = ""
            this.$message({
              showClose: true,
              message: "转接成功",
              type: "success",
              offset: 50,
            })
          }
        } else {
          this.$message({
            showClose: true,
            message: "请输入转接号码",
            type: "error",
            offset: 50,
          })
        }
      }
    },

    initCall() {
      const that = this
      that.callTool = new ghToolbar("mySoftphone")
      // this.toACD();
      //来电监控
      that.callTool.OnAnswerConnected(function () {
        var phone = that.callTool.GetCaller()
        that.aghentPhone = phone.replace(/\b(0+)/gi, "") //将来电号码前的0去掉
        // console.log("坐席来电" + phone)
      })
      //振铃监控 此事件与来电可只处理一种 具体按需求来，若要求来电就弹屏 可用此事件
      that.callTool.OnTelephoneRing(function (szCaller, szCallid) {
        // console.log(
        //     "坐席来电振铃事件，szCaller=" +
        //         szCaller +
        //         ",szCallid=" +
        //         szCallid
        // )
        var phone = szCaller.replace(/\b(0+)/gi, "") //将来电号码前的0去掉
        // console.log("坐席来电" + phone)
        that.$emit("iAgentState", phone)
      })
      //坐席状态监控
      that.stateMonitor()
    },
    //坐席状态监控
    stateMonitor() {
      const that = this
      that.callTool = new ghToolbar("mySoftphone")
      that.callTool.OnAgentStateChanged(function (iAgentState) {
        // console.log("坐席状态改变事件，iAgentState=" + iAgentState)
        switch (iAgentState) {
          case 5:
            alert("坐席状态改变事件======5")
            that.statusDic = "5"
            this.$store.commit("statusDic", this.statusDic)
            if (that.statusDic == "2") {
              that.callTool.SetAgentState(2)
              that.updateAgentXianState()
            }
            break
          case 0:
            alert("坐席状态改变事件======0")
            that.callTool.SetAgentState(2)
            that.updateAgentXianState()
            break
          case 4:
            alert("坐席状态改变事件======4")
            that.updateAgentMangState()
            break
          case 7:
            alert("坐席状态改变事件======7")
            that.updateAgentMangState()
            break
          case 8:
            alert("坐席状态改变事件======8")
            that.updateAgentXianState()
            break
          case 9:
            var isBusy = 0
            break
          default:
            var isBusy = 1
            break
        }
      })
    },
    //连接ACD服务器
    toACD() {
      // console.log("连接ACD服务器")
      const that = this
      that.callTool = new ghToolbar("mySoftphone")
      //连接ACD服务器
      var r = that.callTool.ConnectToACD("192.168.5.5", 3000)
      // console.log("调用ConnectToACD方法, 返回值=" + r)
      if (r == "1") {
        that.callTool.OnAgentConnectToACD(function (bResult) {
          // console.log("连接服务器返回事件，bResult=", bResult)
          //连接正常  登录客服账号
          if (bResult == 1 || bResult == -2) {
            that.ACDlogin()
          } else {
            this.$message({
              showClose: true,
              message: "连接坐席服务器失败",
              type: "error",
              offset: 50,
            })
          }
        })
      }
    },
    ACDlogin() {
      const that = this
      var userIds = this.$props.userId
      let agentId = this.seatNo //坐席工号  身份号
      let agentName = this.username //坐席名称
      let ext = String(this.callIdDic).trim() //坐席分机号
      let groupId = this.agentGroupId //坐席ID
      let levelId = this.agentChannel //坐席等级
      let username = this.username
      let name = this.name

      // console.log("this.agentId", this.name)
      // console.log("this.userIds", that.$props.userId)
      // console.log("this.agentName", this.username)
      // console.log("this.ext", this.callIdDic)
      // console.log("this.groupId", this.agentGroupId)
      // console.log("this.levelId", this.agentChannel)
      // console.log("this.username", this.username)
      // console.log("this.name", this.name)
      // console.log("========================")

      let rightId = 0 //坐席权限（0 普通坐席 ， 1 班长坐席）this.callIdDic
      var LoginExResult = that.callTool.LoginEx(
        agentId,
        agentName,
        ext,
        groupId,
        levelId,
        rightId,
        2
      )
      // console.log("调用LoginEx方法, 返回值=", LoginExResult)
      if (LoginExResult == true) {
        that.stateId = "2"
        that.$store.commit("stateId", that.stateId)
        that.createState("2")

        that.statusDic = "2"
        that.$store.commit("statusDic", that.statusDic)
        that.updateAgentXianState()

        if (userIds != null && userIds != "") {
          that.updateAgentType(userIds, 1, 2)
        }
        let state = this.getAgentStateOpt()

        if (state == -1) {
          state = 0
          this.statusDic = state
          that.$store.commit("statusDic", that.statusDic)
          this.$message({
            showClose: true,
            message: "坐席登陆失败！不是当前坐席",
            type: "error",
            offset: 50,
          })
        } else {
          this.$message({
            showClose: true,
            message: "坐席登录成功",
            type: "success",
            offset: 50,
          })
          // if (this.$store.state.centerPhone) {
          //     this.aghentPhone = this.$store.state.centerPhone
          //     this.dialingOpt()
          // }
        }
      } else {
        this.$message({
          showClose: true,
          message: "登录失败！请检查坐席连接！",
          type: "error",
          offset: 50,
        })
      }
    },
    // 修改坐席状态接口
    updateAgentType(userId, type, statue) {
      request({
        url: "/jjyl/agent/info/updateAgentTypes",
        method: "POST",
        data: {
          ids: this.$props.userId,
          type: type,
          belongAddressId: "06a942d7-0241-4428-8f6f-bbf0695e60ae",
          username: this.username,
          agentid: this.callIdDic,
          states: 0,
          callStatus: statue,
        },
      }).then((resp) => {
        if (resp.code == "200") {
          this.statusDic = statue
          this.$store.commit("statusDic", this.statusDic)
        } else if (resp.code == "500") {
        }
      })
    },
    //修改状态函数
    createState(val) {
      // console.log(val)
      this.stateList.forEach((item) => {
        if (item.value == val) {
          this.stateLabel = item.label
        }
      })
    },
    // 坐席状态修改
    statesStatusChange(val) {
      const that = this
      let agentState = that.getAgentStateOpt()
      var userIds = that.$props.userId
      if (val == "4") {
        // 置忙
        let setAgentStateResult = that.callTool.SetAgentState("4")
        if (setAgentStateResult) {
          // this.$message({
          //   message: '设置状态为置忙成功',
          //   type: 'success'
          // });
          that.stateId = val
          that.$store.commit("stateId", that.stateId)
          that.createState(val)
          that.statusDic = val
          that.$store.commit("statusDic", that.statusDic)
          that.updateAgentMangState()
          that.updateAgentType(userIds, "1", 4)
        }
      } else if (val == "2") {
        // 置闲
        let setAgentStateResult = that.callTool.SetAgentState("2")
        if (setAgentStateResult) {
          // this.$message({
          //   message: '设置状态为置闲成功',
          //   type: 'success'
          // });
          that.stateId = val
          that.$store.commit("stateId", that.stateId)
          that.createState(val)
          that.statusDic = val
          that.$store.commit("statusDic", that.statusDic)
          that.updateAgentXianState()
          that.updateAgentType(userIds, "1", 2)
        }
      } else {
        this.$message({
          showClose: true,
          message: "登录失败！请检查坐席连接！",
          type: "error",
          offset: 50,
        })
      }
    },
    // 坐席状态修改
    statesStatusChange1(val) {
      const that = this
      let agentState = that.getAgentStateOpt()
      var userIds = that.$props.userId
      if (val == "4") {
        // 置忙
        let setAgentStateResult = that.callTool.SetAgentState("4")
        if (setAgentStateResult) {
          // this.$message({
          //   message: '设置状态为置忙成功',
          //   type: 'success'
          // });
          that.stateEdit = false
          that.stateId = val
          that.$store.commit("stateId", that.stateId)
          that.createState(val)
          that.statusDic = val
          that.$store.commit("statusDic", that.statusDic)
          that.updateAgentMangState()
          that.updateAgentType(userIds, "1", 4)
        }
      } else if (val == "2") {
        // 置闲
        let setAgentStateResult = that.callTool.SetAgentState("2")
        if (setAgentStateResult) {
          // this.$message({
          //   message: '设置状态为置闲成功',
          //   type: 'success'
          // });
          that.stateEdit = true
          that.stateId = val
          that.$store.commit("stateId", that.stateId)
          that.createState(val)
          that.statusDic = val
          that.$store.commit("statusDic", that.statusDic)
          that.updateAgentXianState()
          that.updateAgentType(userIds, "1", 2)
        }
      } else {
        this.$message({
          showClose: true,
          message: "登录失败！请检查坐席连接！",
          type: "error",
          offset: 50,
        })
      }
    },
    // 转接
    transferChange(val) {
      this.transferDic = val
    },
    // 坐席ID选择
    callIdChange(val) {
      this.callIdDic = val
      this.$store.commit("setNo", val)
    },
    // 会议
    meetingChange(val) {
      this.meetingDic = val
    },
    // 置闲
    updateAgentXianState() {
      request({
        url: "/jjyl/agent/info/updateAgentXianStates",
        method: "POST",
        data: {
          ids: this.$props.userId,
          belongAddressId: "06a942d7-0241-4428-8f6f-bbf0695e60ae",
          username: this.username,
          agentid: this.callIdDic,
        },
      }).then((resp) => {
        if (resp.code == "200") {
          this.statusDic = "2"
          this.$store.commit("statusDic", this.statusDic)
        } else if (resp.code == "500") {
        }
      })
    },
    // 置忙
    updateAgentMangState() {
      request({
        url: "/jjyl/agent/info/updateAgentMangStates",
        method: "POST",
        data: {
          ids: this.$props.userId,
          belongAddressId: "06a942d7-0241-4428-8f6f-bbf0695e60ae",
          username: this.username,
          agentid: this.callIdDic,
        },
      }).then((resp) => {
        if (resp.code == "200") {
          this.statusDic = "4"
          this.$store.commit("statusDic", this.statusDic)
          if (resp.content != null) {
          } else {
          }
        }
      })
    },
    // 就绪
    readyOpt() {
      this.initCall()
    },
    // 接听
    answerCallsOpt() {
      this.OffHook()
      // this.outCall = 1
    },
    // 拨号 先置忙再外呼 外地手机号要加0
    dialingOpt1() {
      const that = this
      request({
        url: "/jjyl/traffic/callInfo/info/findSeatInfo",
        method: "POST",
        data: {
          agentID: 1014,
          outCall: 1,
        },
      }).then((res) => {
        if (res.code === 200) {
          that.trafficState = true
          //
          // console.log("我获取的数据", res.content)
          that.trafficInfo = {
            state: true,
            phone: res.content.phone,
            outCall: that.outCall,
            callid: res.content.callID,
            callmanid: res.content.callmanid,
            callman: res.content.callman,
          }
        }
      })
    },
    dialingOpt(val) {
      if (val == 1) {
        //1代表头部打电话传过来得参数
        this.nextState = false
      }
      if (val == 2) {
        //2代表工单打电话传过来得参数
        this.nextState = true
      }
      const that = this
      that.isDial = false
      let agentState = that.getAgentStateOpt()
      // 坐席状态为4=置忙 可外呼  需先置忙，在外呼
      if (agentState != "4" && agentState != "5") {
        that.statesStatusChange("4")
      }
      // console.log(that.aghentPhone, "电话号码")
      if (that.aghentPhone != null && that.aghentPhone != "") {
        // that.trafficState = true
        // that.trafficInfo = { state: true, phone: that.aghentPhone }

        // 坐席外呼
        this.$store.dispatch("setPhone", this.aghentPhone)
        var r = that.callTool.Dial(that.aghentPhone.trim())
        // alert("坐席外呼返回事件，返回值=" + r);
        if (!r) {
          that.$message({
            showClose: true,
            message: "外拨失败-1",
            type: "error",
            offset: 50,
          })
          // 坐席外呼失败 取消外呼 调用该方法后会触发事件 线路状态改变 OnLineStateChanged
          that.callTool.CancelDial()
          that.onLineStateChangedOpt()
          that.statusDic = "2"
          that.$store.commit("statusDic", that.statusDic)
        } else {
          // alert('外呼成功 外呼号码' + that.aghentPhone)
          // 坐席呼出后触发该事件 呼出结果（TRUE=成功、FALSE=失败）
          that.callTool.OnAgentDial((bResult) => {
            // alert('bResult外呼后返回值' + bResult)
            if (!bResult) {
              that.$message({
                showClose: true,
                message: "外拨失败-2",
                type: "error",
                offset: 50,
              })
              that.callTool.CancelDial()
              that.onLineStateChangedOpt()
              that.statusDic = "2"
              that.$store.commit("statusDic", that.statusDic)
            } else {
              that.stateId = "3"
              that.$store.commit("stateId", that.stateId)
              that.createState("3")
              that.statusDic = "3"
              that.$store.commit("statusDic", that.statusDic)
              // 坐席外呼接通
              that.callTool.OnDialConnected()
              this.outCall = 1
              that.$store.commit("outCall", that.outCall)
              // console.log(
              //     that.nextState,
              //     "判断进来的状泰 是什么形式"
              // )
              if (that.nextState == false) {
                //true代表工单打进来的
                setTimeout(() => {
                  that.phoneInfo()
                }, 2000)
              }
            }
          })
        }
      } else {
        that.$message({
          showClose: true,
          message: "请输入需要外拨的号码",
          type: "error",
          offset: 50,
        })
      }
    },
    // 保持
    keepCallOpt() {
      const that = this
      let lineState = that.getLineStateOpt()
      var userIds = that.$props.userId
      if (lineState == "3") {
        // 保持
        that.holdOpt()
        that.updateAgentType(userIds, "1", 3)
      } else if (lineState == "4") {
        // 保持状态下取保持
        that.unHoldOpt()
        that.updateAgentType(userIds, "1", 3)
      } else {
        that.$message({
          showClose: true,
          message: "当前没有通话或保持下通话",
          type: "error",
          offset: 50,
        })
        return
      }
    },
    // 挂断
    hangUpOpt() {
      const that = this
      let lineState = that.getLineStateOpt()
      var userIds = that.$props.userId
      if (lineState != "7") {
        let r = that.callTool.Onhook()
        if (!r) {
          if (that.callState == "7") {
            that.$message({
              showClose: true,
              message: "已挂断",
              offset: 50,
            })
          }
        } else {
          that.$message({
            showClose: true,
            message: "已挂断",
            offset: 50,
          })
          that.stateId = "5"
          that.$store.commit("stateId", that.stateId)
          that.createState("5")
          that.statusDic = "5"
          that.$store.commit("statusDic", that.statusDic)
          that.updateAgentType(userIds, "1", 5)
          setTimeout(() => {
            that.statesStatusChange("2")
          }, 60000)
        }
      }
    },
    // 线路状态改变
    onLineStateChangedOpt() {
      const that = this
      let currentState = ""
      that.callTool.OnLineStateChanged((iLineState) => {
        currentState = iLineState
        switch (iLineState) {
          case 0:
            that.callTool.SetAgentState(4)
            break
          case 1:
            console.log("振铃")
            break
          case 2:
            console.log("拨号")
            break
          case 3:
            console.log("通话")
            break
          case 4:
            console.log("保持")
            break
          case 5:
            console.log("保持下拨号")
            break
          case 6:
            console.log("保持下通话")
            break
          case 7:
            console.log("挂机")
            break
          case 8:
            console.log("摘机")
            break
          case 9:
            console.log("咨询")
            break
          case 10:
            console.log("转移")
            break
          case 11:
            console.log("取保持")
            break
          case 12:
            console.log("三方")
            break
          case 13:
            console.log("会议")
            break
          case 14:
            console.log("监听")
            break
          case 15:
            console.log("强插")
            break
          case 16:
            console.log("拦截")
            break
          default:
            console.log("未知状态")
            break
        }
      })
      return currentState
    },
    /*
      获取坐席状态
      坐席状态(-1=未知状态、0=离席、1=登录、2=置闲、3=话务忙、4=人工忙、5=话后忙、6=被锁定分配、7=强置忙、8=强置闲）
  */
    getAgentStateOpt() {
      const that = this
      return that.callTool.GetAgentState()
    },
    /*
      获取线路状态
      线路状态（-1=未知状态、0=空闲、1=振铃、2=拨号、3=通话、4=保持、5=保持下拨号、6=保持下通话、7=挂机、8=摘机、9=咨询、10=转移、11=取保持、12=三方、13=会议、14=监听、15=强插、16=拦截）
  */
    getLineStateOpt() {
      const that = this
      return that.callTool.GetLineState()
    },
    // 通话摘机 坐席摘机接听电话
    OffHook() {
      const that = this
      let r = that.callTool.Offhook()
      // console.log("摘机接听---")
      if (r) {
        // that.trafficState = true
        // that.trafficInfo = { state: true, phone: "13955063192" }
        this.outCall = 0
        that.$store.commit("outCall", that.outCall)
        setTimeout(() => {
          that.phoneInfo()
        }, 2000)
        this.$message({
          showClose: true,
          message: "摘机成功",
          type: "success",
          offset: 50,
        })
      }
    },

    // 通话保持 坐席处于通话状态时，才能保持通话
    holdOpt() {
      const that = this
      let r = that.callTool.Hold()
      if (r) {
        that.$message({
          showClose: true,
          message: "保持成功",
          type: "success",
          offset: 50,
        })
        that.holdText = "取保持"
        that.$store.commit("holdText", that.holdText)
      }
    },
    // 通话取保持 在坐席处于保持状态时，才能取回被保持的通话
    unHoldOpt() {
      const that = this
      let r = that.callTool.UnHold()
      if (r) {
        that.$message({
          showClose: true,
          message: "取保持成功",
          type: "success",
          offset: 50,
        })
        that.holdText = "保持"
        that.$store.commit("holdText", that.holdText)
      }
    },
  },
  destroyed() {
    if (this.$store.state.info.seatNo == null) {
      this.$store.commit("setNo", "")
    } else {
      this.$store.commit("setNo", this.$store.state.info.seatNo)
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.$store.dispatch("setPhone", "")
  },
  components: {
    DialogHomePage,
    trafficOpen,
  },
}
</script>

<style lang="less" scoped>
/deep/ .el-button--medium {
  padding: 7px 20px;
}
.callOpt {
  margin: 15px 0;
  padding: 10px 0;
  background: #ffffff;
  border-radius: 16px;
}

.callOpt .el-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* 输入拨打号码 */
.callNumberWrap {
  position: relative;
  margin-left: 20px;
}

.callNumberEdit {
  position: relative;
}

.callNumberEdit .el-input__inner {
  padding: 0 12px;
  /* width: 300px; */
  width: 100%;
  height: 32px;
  border: 1px solid rgba(224, 224, 224, 1);
  box-sizing: border-box;
  border-radius: 40px;
}

.callNumberIcon {
  position: absolute;
  top: 8px;
  right: 10px;
  width: 16px;
  /* transform: translate(0, -50%); */
}

.cameraIcon {
  margin: 0 8px;
  width: 18px;
  height: 15px;
}

.phoneBookIcon {
  width: 16px;
  height: 16px;
}

/* 状态 */
.status {
  margin: 0 7px 0 16px;
}

.statusIcon {
  width: 12px;
  height: 12px;
}

/* 转接 */ /* 会议 */
.transfer,
.meeting {
  margin-left: 12px;
}

.meeting {
  margin-right: 18px;
}

/* 呼叫操作 */
.callOptIconWrap {
  margin: 0;
  padding: 0;
  height: 100%;
  display: flex;
  align-items: center;
}

.callOptIconWrap li {
  list-style: none;

  p {
    font-size: 14px;
    color: #666666;
    white-space: nowrap;
  }
}

.iconItem {
  margin: 0 1rem;
  text-align: center;
}

.icon {
  height: 2rem;
  border-radius: 50%;
}

.flex {
  display: flex;
}

.justify-around {
  justify-content: space-around;
}

.justify-end {
  justify-content: flex-end;
  margin-right: 20px;
}

.align-center {
  align-items: center;
}

.active:hover {
  cursor: pointer;
}

.justify-center {
  justify-content: center;
}

.callOpt [class*=" el-icon-arrow-down"] {
  font-size: 15px;
}

.callOpt [class*=" el-icon-arrow-down"]:before {
  color: #606266;
}

.callOpt .el-button--medium:first-child {
  padding: 8px 30px;
}

.callOpt .el-button--medium:last-child {
  padding: 5px 2px 8px 2px;
}

.el-dropdown__caret-button {
  padding: 8px 2px;
}

.callIdDown {
  max-height: 120px;
  overflow-y: scroll;
}

.el-button {
  margin-bottom: 0 !important;
}
</style>
<style lang="less" scoped>
/deep/ .el-button-group > .el-button:first-child,
/deep/ .el-button-group > .el-button:last-child {
  height: 32px;
  overflow: hidden;
}

/deep/ .el-dropdown .el-button-group {
  display: flex;
}

.el-icon-arrow-down:before {
  color: red !important;
  font-size: 18px;
  content: "\E6DF";
}

.rightIcon {
  margin-right: 20px;
  text-align: center;
  cursor: pointer;

  img {
    width: 35px;
    height: 35px;
  }

  p {
    font-size: 14px;
    color: #666666;
  }
}
</style>
